"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SettingsCardColumns = void 0;
var react_1 = __importDefault(require("react"));
var mobx_react_1 = require("mobx-react");
var classnames_1 = __importDefault(require("classnames"));
var kaleidoscope_1 = require("@qwilr/kaleidoscope");
var SettingsCard = (0, mobx_react_1.observer)(function (_a) {
    var _b;
    var children = _a.children, icon = _a.icon, action = _a.action, heading = _a.heading, description = _a.description, _c = _a.showDivider, showDivider = _c === void 0 ? false : _c;
    return (react_1.default.createElement(kaleidoscope_1.Card, { className: "settings-card" },
        react_1.default.createElement("div", { className: "settings-card__header" },
            react_1.default.createElement("div", { className: "settings-card__header-items" },
                !!icon && react_1.default.createElement("div", { className: "settings-card__icon" }, icon),
                react_1.default.createElement("h2", { className: "settings-card__heading" }, heading),
                !!action && react_1.default.createElement("div", { className: "settings-card__action" }, action)),
            !!description && react_1.default.createElement("p", { className: "settings-card__header-description" }, description)),
        !!children && (react_1.default.createElement("div", { className: (0, classnames_1.default)("settings-card__body", (_b = {},
                _b["settings-card__body--divided"] = showDivider,
                _b)) }, children))));
});
var SettingsCardColumns = function (_a) {
    var children = _a.children;
    return react_1.default.createElement("div", { className: "settings-card__columns" }, children);
};
exports.SettingsCardColumns = SettingsCardColumns;
exports.default = SettingsCard;
